export default __webpack_public_path__ + "static/media/pen-solid.4b1bdc1c.svg";